import { ca } from '@cian/analytics';

export function trackSearchButtonClick(url: string) {
  const urlPairs = url.split('cian.ru');

  ca('eventSite', {
    category: 'main_page',
    action: 'button_search',
    /**
     * Отправляем только queryString, без домена
     */
    label: urlPairs[1] || urlPairs[0],
  });
}
